import ajax from "@/utils/ajax.js";
import tokenService from "@/services/tokenService.js";
import store from '@/store/index.js';
import dayjs from "dayjs";

export default {

    isLogin() { //是否登录
        let token = tokenService.getToken();
        //console.log(dayjs.unix(token.expires_in).add(-8,"hour").format("YYYY-MM-DD HH:mm:ss"));
        if(token){
            if (dayjs.unix(token.expires_in).add(-8,"hour").isAfter(dayjs())) {
                return true;
            }
            if(token.access_token_type=="GDHRSS"){
                this.refreshTokenFormGDHRSSAsync().then((newToken)=>{
                    tokenService.setToken(newToken);
                    token = tokenService.getToken();
                    if (dayjs.unix(token.expires_in).add(-8,"hour").isAfter(dayjs())) {
                        return true;
                    }
                });
            }
        }

        return false;
    },
    async loginFromWeChatAsync(input) {
        let response = await ajax.post("/member/LoginFromWeChatAsync", input);
        return JSON.parse(response.result);
    },
    async loginFromGDHRSSAsync(input) {
        let response = await ajax.post("/member/LoginFromGDHRSSAsync", input);
        return JSON.parse(response.result);
    },
    
    async refreshTokenFormGDHRSSAsync() {
        let response = await ajax.get("/member/RefreshTokenFormGDHRSSAsync");
        return JSON.parse(response.result);
    },
    async refreshTokenAsync() {
        let response = await ajax.get("/member/RefreshTokenAsync");
        return JSON.parse(response.result);
    },
    async getMemberInfoAsync() {
        let response = await ajax.get('/member/GetMemberForWeChatAsync');
        return response.result;
    },
    async getLoginUrl(redirectUrl) {
        if (process.env.NODE_ENV === "development") 
        {
            let loginUrl = `${location.origin}/login?redirect=${
                redirectUrl
              }&date=${new Date().getTime()}`;
            if (location.search) {
                loginUrl += location.search.replace("?", "&");
            }
            let wxLoginUrl = `${loginUrl}&code=123456`;
            return wxLoginUrl;
        }
        else{
            let response = await ajax.get(`/member/GetLoginUrl?redirectUrl=${redirectUrl}`);
            return response.result;
        }
        
    },
    async registMemberCardAsync(input) {
        return await ajax.post("/member/RegistMemberCardAsync", input);
    },
    async getElectronicMemberCardAsync() {
        let response = await ajax.get('/member/GetElectronicMemberCardAsync');
        return response.result;
    },
    async renewMemberCardAsync(id) {
        return await ajax.post("/member/RenewMemberCardAsync", {
            id: id
        });
    },
    async bindStaffAsync(input) {
        return await ajax.post("/member/BindStaffAsync", input);
    },
    async customerLogoutAsync() {
        const token = await this.refreshTokenAsync();
        // tokenService.setToken(token.access_token);
        tokenService.setToken(token);
        await store.dispatch('memberModule/refreshMemberAsync');
    }
}